import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Megaphone, Users2, HandCoins, Trophy, Link2, Building2, Mail, LogOut,
  UserCog, FolderKanban,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import OverviewTab from "@/components/admin/OverviewTab";
import CampaignsTab from "@/components/admin/CampaignsTab";
import TeamsTab from "@/components/admin/TeamsTab";
import DonationsTab from "@/components/admin/DonationsTab";
import LeaderboardTab from "@/components/admin/LeaderboardTab";
import InvitesTab from "@/components/admin/InvitesTab";
import SponsorsTab from "@/components/admin/SponsorsTab";
import EmailTab from "@/components/admin/EmailTab";
import AccountsManage from "@/components/volunteer/AccountsManage";
import ProjectsManage from "@/components/volunteer/ProjectsManage";
import VolunteerDirectory from "@/components/volunteer/VolunteerDirectory";

const TABS = [
  { id: "overview", label: "Overview", icon: LayoutDashboard, C: OverviewTab },
  { id: "campaigns", label: "Campaigns", icon: Megaphone, C: CampaignsTab },
  { id: "teams", label: "Teams & Supporters", icon: Users2, C: TeamsTab },
  { id: "donations", label: "Donations", icon: HandCoins, C: DonationsTab },
  { id: "leaderboard", label: "Leaderboard", icon: Trophy, C: LeaderboardTab },
  { id: "invites", label: "Invites", icon: Link2, C: InvitesTab },
  { id: "sponsors", label: "Sponsors", icon: Building2, C: SponsorsTab },
  { id: "accounts", label: "Accounts", icon: UserCog, C: AccountsManage },
  { id: "projects", label: "Projects & Tasks", icon: FolderKanban, C: ProjectsManage },
  { id: "volunteers", label: "Volunteers", icon: Users2, C: VolunteerDirectory },
  { id: "email", label: "Email Journeys", icon: Mail, C: EmailTab },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [active, setActive] = useState("overview");
  const Active = TABS.find((t) => t.id === active).C;

  const doLogout = () => { logout(); navigate("/"); };

  const NavBtn = ({ t }) => (
    <button
      onClick={() => setActive(t.id)}
      data-testid={`admin-nav-${t.id}`}
      className={`flex shrink-0 items-center gap-2.5 rounded-xl px-3.5 py-2.5 text-sm font-semibold transition-colors ${
        active === t.id
          ? "bg-[#00334a] text-white shadow-sm"
          : "text-[#3f6670] hover:bg-[#efe6d6]"
      }`}
    >
      <t.icon className="h-4.5 w-4.5 h-[18px] w-[18px]" /> <span className="whitespace-nowrap">{t.label}</span>
    </button>
  );

  return (
    <div className="min-h-screen bg-[#f8f3e9]">
      <header className="sticky top-0 z-40 hf-glass border-b border-[#e4d8c4]/70">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-3">
          <div className="flex items-center gap-3">
            <Brand />
            <span className="hidden rounded-full bg-[#f3e7db] px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#b05e3c] sm:inline">
              Staff Admin
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden text-sm font-semibold text-[#3f6670] md:inline">{user.name}</span>
            <Button variant="outline" size="sm" onClick={doLogout} className="rounded-full border-[#e4d8c4] text-[#3f6670]" data-testid="admin-logout-button">
              <LogOut className="mr-1.5 h-4 w-4" /> Sign out
            </Button>
          </div>
        </div>
      </header>

      <div className="mx-auto flex max-w-[1400px] gap-6 px-5 py-6">
        <aside className="hidden w-60 shrink-0 lg:block">
          <nav className="sticky top-20 space-y-1">
            {TABS.map((t) => <NavBtn key={t.id} t={t} />)}
          </nav>
        </aside>

        <main className="min-w-0 flex-1">
          <div className="mb-5 flex gap-2 overflow-x-auto pb-1 lg:hidden">
            {TABS.map((t) => <NavBtn key={t.id} t={t} />)}
          </div>
          <Active />
        </main>
      </div>
    </div>
  );
}
